import { UseFormReturn } from 'react-hook-form';
import { BeneficialOwnerFormType, EnterpriseStructure, beneficialOwnerFormSchema } from '@brighte/validation';
import { StepNavigator } from '@components/StepNavigator';
import { getEnumKey } from '@components/StepNavigator/helper';
import { useApplicationData } from '@provider';
import { APPLICATION_STEPS, BENEFICIAL_OWNER_DETAILS, pascalToCamelCase } from '../../utils';
import BeneficialOwner from '../OwnershipDetails/BeneficialOwner';
import { useBeneficialOwnerSummary } from './hooks';

function BeneficialOwnerForm() {
  const { TITLE } = BENEFICIAL_OWNER_DETAILS;
  const {
    quote,
    BeneficialOwner: beneficialOwner,
    BusinessDetails,
  } = useApplicationData(['quote', 'BeneficialOwner', 'BusinessDetails']);
  const financialProductId = quote?.financialProduct?.id ?? '';

  const structure = BusinessDetails?.enterprise?.structure;
  const structureProp = structure ? pascalToCamelCase(getEnumKey(structure, EnterpriseStructure)) : undefined;

  const beneficialOwners = structureProp ? beneficialOwner?.enterprise?.[structureProp]?.beneficialOwners || [] : [];
  const completedContent = useBeneficialOwnerSummary();

  if (!structureProp || !structure) {
    return null;
  }

  const defaultValues = beneficialOwner ?? {
    financialProductId,
    enterprise: {
      structure,
      [structureProp]: {
        beneficialOwners: [],
      },
    },
  };

  return (
    <StepNavigator<BeneficialOwnerFormType>
      schema={beneficialOwnerFormSchema}
      name={APPLICATION_STEPS.BENEFICIAL_OWNER}
      title={TITLE}
      defaultValues={defaultValues}
      completedContent={completedContent}
    >
      {({ register, ...formProps }: UseFormReturn<BeneficialOwnerFormType>) => {
        return (
          <>
            <BeneficialOwner
              name={`enterprise.${structureProp}.beneficialOwners`}
              businessType={structure}
              defaultValues={beneficialOwners}
              financialProductId={financialProductId}
              {...formProps}
            />
            <input type="hidden" {...register('financialProductId')} value={financialProductId} />
            <input type="hidden" {...register('enterprise.structure')} value={structure} />
          </>
        );
      }}
    </StepNavigator>
  );
}

export default BeneficialOwnerForm;
